import {fsa, fsaError, fsaPayload, fsaPayloadByKeys} from './helpers'

export const GET_ORDERS = 'get orders per orderId'
export const getOrders = fsaPayloadByKeys(GET_ORDERS, ['orderId'])

export const GET_ORDERS_PENDING = 'get orders per orderId pending'
export const getOrdersPending = fsa(GET_ORDERS_PENDING)

export const GET_ORDERS_FAILURE = 'get orders per orderId failure'
export const getOrdersFailure = fsaError(GET_ORDERS_FAILURE)

export const GET_ORDERS_SUCCESS = 'get orders per orderId succeeded'
export const getOrdersSuccess = fsaPayload(GET_ORDERS_SUCCESS)
